export default "__VITE_ASSET__Bh_xweF$__"